import { useCardData } from '../../internal/CardDataContext';
import CardContentSpinner from './CardContentSpinner';
import TextListSkeleton from './TextListSkeleton';
import { CHICLET_LIST, DEFAULT_LOADING_COMPONENT_PROPS, TEXT_LIST } from '../../constants/LoadingComponentProps';
import ChicletListSkeleton from './ChicletListSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CardContentLoadingComponent() {
  const {
    cardData,
    loadingComponentProps = DEFAULT_LOADING_COMPONENT_PROPS
  } = useCardData();
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": `card-content-loading-${cardData.definition.cardId}`,
    children: loadingComponentProps.map((props, idx) => {
      if (props.type === TEXT_LIST) {
        return /*#__PURE__*/_jsx(TextListSkeleton, Object.assign({}, props, {
          cardId: cardData.definition.cardId
        }), `${idx}-${props.type}-${props.count}`);
      }
      if (props.type === CHICLET_LIST) {
        return /*#__PURE__*/_jsx(ChicletListSkeleton, Object.assign({}, props, {
          cardId: cardData.definition.cardId
        }), `${idx}-${props.type}-${props.numberOfSkeletons}-${props.numberOfProperties}`);
      }
      return /*#__PURE__*/_jsx(CardContentSpinner, {
        minHeight: props.minHeight
      }, `${idx}-${props.type}-${props.minHeight}`);
    })
  });
}